import { render } from "./ProgramItem.vue?vue&type=template&id=02b7e8c2&scoped=true"
import script from "./ProgramItem.vue?vue&type=script&lang=js"
export * from "./ProgramItem.vue?vue&type=script&lang=js"

import "./ProgramItem.vue?vue&type=style&index=0&id=02b7e8c2&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b7e8c2"]])

export default __exports__